export default "__VITE_ASSET__BX0nxJ3V__"